import React from 'react';
import { Center, Card } from '@mantine/core';
import { SubmittableTechnology } from '../../../backend/models/technology';
import TechnologyForm from './Form';
import { addTechnology } from '../../Util/server';
import { useLoaderData } from 'react-router-dom';
import { AggregatedDataLoaderResult } from '../../Loaders/AggregatedDataLoader';

const NewTechnology = () => {
  const { technologies, rings, sections, tags, clients, persons } = useLoaderData() as AggregatedDataLoaderResult;
  return (
    <Center>
      <Card withBorder shadow="sm">
        <TechnologyForm
          rings={rings}
          sections={sections}
          tags={tags}
          clients={clients}
          persons={persons}
          names={technologies.map((t) => t.name)}
          buttonLabel="Add"
          onSubmit={(values: SubmittableTechnology) => addTechnology(values)}
          add
          successMessage="Technology added to radar"
        />
      </Card>
    </Center>
  );
};

export default NewTechnology;
